import { EmoticonLolOutlineIcon } from './EmoticonLolOutlineIcon';

/**
 * author: Michael Richins
 * id 2A7BA4B1-C436-4EE6-BF5A-34B150A9A746
 * name emoticon-lol-outline
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-lol-outline.svg
 * tags
 * - Emoji 
 */
export const EmojiLolOutlineIcon = EmoticonLolOutlineIcon;
export default EmojiLolOutlineIcon